import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ContactHistoryParts = [
  'container',
  'headerContainer',
  'headerText',
  'timespanText',
  'scrollContainer',
  'stepperContainer',
] as const

const helpers = createMultiStyleConfigHelpers(ContactHistoryParts)

export const ContactHistoryStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      backgroundColor: 'bg.default',
      flex: { base: '1 0 0', lg: 'none' },
      height: { base: 'fit-content', sm: 'auto' },
      width: { base: 'auto', lg: '28.75rem', xl: '40rem' },
      paddingX: '1.75rem',
      paddingTop: '2.5rem',
      paddingBottom: '1.25rem',
      borderRadius: '0.5rem',
      border: '2px solid',
      borderColor: 'border.muted',
    },
    headerContainer: {
      justifyContent: 'space-between',
      width: 'full',
      paddingBottom: '0.75rem',
      borderBottom: '1px solid',
      borderColor: 'border.default',
    },
    headerText: {
      ...textStyles[textStyleKeys.Body2_Bold],
    },
    timespanText: {
      ...textStyles[textStyleKeys.Body2],
    },
    scrollContainer: {
      overflowY: { base: 'visible', sm: 'scroll' },
    },
    stepperContainer: {
      paddingTop: '1.75rem',
    },
  },
})

export const useContactHistoryStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactHistoryStyle, props) as MultiStyleType<
    typeof ContactHistoryParts
  >
}
